import {Injectable} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {Icon} from '../models/ui/icon';

@Injectable()
export class IconService {

  constructor(private _matIconRegistry: MatIconRegistry, private _domSanitizer: DomSanitizer) {
  }

  public registerIcons(icons: Icon[]): void {
    icons.forEach((icon) => this._matIconRegistry.addSvgIconLiteral(icon.name, this._domSanitizer.bypassSecurityTrustHtml(icon.source)));
  }

}
